var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6161 11.1161C12.1043 10.628 12.8957 10.628 13.3839 11.1161L16.5 14.2322L19.6161 11.1161C20.1043 10.628 20.8957 10.628 21.3839 11.1161C21.872 11.6043 21.872 12.3957 21.3839 12.8839L18.2678 16L21.3839 19.1161C21.872 19.6043 21.872 20.3957 21.3839 20.8839C20.8957 21.372 20.1043 21.372 19.6161 20.8839L16.5 17.7678L13.3839 20.8839C12.8957 21.372 12.1043 21.372 11.6161 20.8839C11.128 20.3957 11.128 19.6043 11.6161 19.1161L14.7322 16L11.6161 12.8839C11.128 12.3957 11.128 11.6043 11.6161 11.1161Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.0f443b253af7aa364068de7a44830e5d.svg";
export { ForwardRef as ReactComponent };